import { render, staticRenderFns } from "./addExpenses.vue?vue&type=template&id=6463e7ff&scoped=true"
import script from "./addExpenses.vue?vue&type=script&lang=js"
export * from "./addExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6463e7ff",
  null
  
)

export default component.exports